import {
  ManualTranscript,
  MediaSegmentData,
  VideoLayoutTimeline,
  VideoUpload,
} from '@sparemin/api-sdk';
import {
  EmbedLoadContext,
  EmbedLoadPayload,
} from '@sparemin/embed-service-messaging';
import {
  embedManualTranscriptSelector,
  getVideoUploadSelector,
  mapStateToEmbedConfig,
  mediaSegmentInfoIdsSelector,
  videoIdsSelector,
  videoLayoutTimelineIdsSelector,
} from 'redux/modules/embed/selectors';
import {
  getVideoLayoutTimelineSelector,
  mediaSegmentDataSelector,
} from 'redux/modules/entities';
import { State } from 'redux/types';

const embedLoadContextSelector = (state: State): EmbedLoadContext => {
  const manualTranscript = embedManualTranscriptSelector(state);
  const transcriptInfo = manualTranscript
    ? (manualTranscript.toJS() as ManualTranscript)
    : undefined;

  const mediaSegmentInfoIds = mediaSegmentInfoIdsSelector(state) ?? [];
  const mediaSegmentInfo = mediaSegmentInfoIds
    .map(({ id }) => mediaSegmentDataSelector(state, id))
    .filter(Boolean) as MediaSegmentData[];

  const layoutTimelineIds = videoLayoutTimelineIdsSelector(state) ?? [];
  const videoLayoutTimelineInfo = layoutTimelineIds
    .map(({ uuid }) => {
      const timeline = getVideoLayoutTimelineSelector(uuid)(state);
      return timeline && (timeline.toJS() as VideoLayoutTimeline);
    })
    .filter(Boolean) as VideoLayoutTimeline[];

  const videoIdsImmutable = videoIdsSelector(state);
  const videoIds = videoIdsImmutable
    ? (videoIdsImmutable.toArray() as number[])
    : [];
  const videoInfo = videoIds
    .map(videoId => getVideoUploadSelector(String(videoId))(state))
    .filter(Boolean) as VideoUpload[];

  return {
    transcriptInfo,
    mediaSegmentInfos: mediaSegmentInfo.length ? mediaSegmentInfo : undefined,
    videoLayoutTimelineInfos: videoLayoutTimelineInfo.length
      ? videoLayoutTimelineInfo
      : undefined,
    videoInfos: videoInfo.length ? videoInfo : undefined,
  };
};

export const embedLoadMessageSelector = (state: State): EmbedLoadPayload => ({
  type: 'embed.load',
  embedConfig: mapStateToEmbedConfig(state),
  context: embedLoadContextSelector(state),
});
